// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("js/" + chunkId + "." + "bc2a1248" + ".js");